window.OBCustomDocumentsForm = function (scope) {
    var form = this;
    var formName = "ob_custom_documents_form";
    var _protected = BaseForm.call(form, formName, scope);

    form.newDocs = [];
    form.dateDay = moment().format('YYYY-MM-DD');
    form.boosterDate = moment().subtract(1, 'days');
    form.addNewDocument = function () {
        form.newDocs.push({
            code: OnBoardingAPI.DOCUMENT_TYPE.CUSTOM_DOCUMENT,
            viewableByCandidate: "false"
        });
    };

    form.DOCUMENTS_WITHOUT_EXPIRATION_DATE = [
        OnBoardingAPI.DOCUMENT_TYPE.CUSTOM_DOCUMENT,
        'CUSTOM_MINOR_DOCUMENTS',
        OnBoardingAPI.DOCUMENT_TYPE.VACCINATION_CARD,
    ];

    //Select file to be uploaded
    form.selectFile = function (doc, files) {
        if (files && files[0]) {
            var fileSize = new HFileSize(files[0]).type('docs');
            if(!fileSize.allowed()){
                fileSize.showError();
            }
            else{
                doc.uploadingError='';
                var fileType = Utils.getFileType(files[0]);

                if ((fileType.indexOf("image/") > -1 && fileType.indexOf("image/gif") == -1) || fileType.indexOf("/pdf") > -1) {
                    doc.selectedFile = files[0];
                    //remove extension from the file name
                    doc.name = doc.selectedFile.name.replace(/.[^.]+$/, '');
                } else {
                    hAlert($filter("translate")("Invalid file type") + ": " + files[0].name, $filter("translate")("Attachment should be image or PDF file."))
                }
            }
        }
    }

    form.filterDocumentsByCode = code => {
        const hasSystemDocument = form.availableDocs.some(doc => {
            return doc.code === code && doc.lookup_type === "SYSTEM_DOCUMENT";
        });
        return hasSystemDocument;
    };


    //Delete a selected file
    form.deleteSelectedFile = function (docIndex) {
        form.validator.clearValidate(docIndex);
        form.newDocs.splice(docIndex, 1);
        if (!form.newDocs.length) {
            form.addNewDocument();
        }
    };
};
